import jwt from 'jsonwebtoken'

import { JWTToken } from '../types/Input'

export const decode = (token: string): JWTToken => jwt.decode(token) as JWTToken
